module.exports = __webpack_public_path__ + "static/media/landscape.e8733fc4.webp";